import { lockScroll, unlockScroll } from "./Scroll";
import { openModalBackdrop, closeModalBackdrop } from "./ModalBackdrop";

export default class ModalController {
  constructor({ modal, backdrop, closeBtn, openClass = "is-open", onOpen, onClose }) {
    this.modal = modal;
    this.backdrop = backdrop;
    this.closeBtn = closeBtn;
    this.openClass = openClass;
    this.onOpen = onOpen;
    this.onClose = onClose;

    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.closeBtn?.addEventListener("click", () => this.close());
    this.backdrop?.addEventListener("click", () => this.close());
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) this.close();
    });
  }

  open() {
    openModalBackdrop(this);
    lockScroll();

    this.isOpen = true;
    this.modal.classList.add(this.openClass);
    this.onOpen?.();
  }

  close() {
    this.isOpen = false;

    unlockScroll();
    closeModalBackdrop(this);
    this.modal.classList.remove(this.openClass);
    this.onClose?.();
  }
}
